//@ts-check

import React, { useEffect, useRef } from "react"
import { withStyles } from "@material-ui/core/styles"
import Avatar from "@material-ui/core/Avatar"
import ErrorIcon from "@material-ui/icons/Error"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import Box from "@material-ui/core/Box"
import Link from "@material-ui/core/Link"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import useStyles from "./styles.js"
import CONSTS from "../../../shared/consts"

const errorStyle = {
  buttonColor: "#E9746D",
  alignItems: "flex-start",
  fontFamily: "EYInterstate",
  fontStyle: "normal",
  fontWeight: 300,
  fontSize: "14px",
  color: "#2E2E38",
}

const listContainerStyles = {
  "&:nth-child(even)": {
    filter: "brightness(96%)",
  },
  "&:hover": {
    filter: "brightness(85%)",
  },
}

const ErrorListItem = withStyles({
  root: {
    ...listContainerStyles,
    ...errorStyle,
  },
})(ListItem)

const ErrorAvatar = withStyles({
  root: {
    backgroundColor: "transparent",
    color: "#B9251C",
  },
})(Avatar)

const ClassicLink = withStyles({
  root: {
    color: "#0000ee",
    cursor: "pointer",
  },
})(Link)

const errorAvatar = () => (
  <ErrorAvatar>
    <ErrorIcon />
  </ErrorAvatar>
)
/**
 * @param props {{
 * compilationErrors: {formattedMessage:string,type,severity }[],
 * scrollToSource?: any,
 * hideTitle?: boolean
 * }}
 */
var CompilationErrorsBox = ({ compilationErrors, scrollToSource, hideTitle }) => {
  const { t } = useTranslation()
  const sectionRef = useRef(null)

  useEffect(function scrollIntoSection() {
    window.requestAnimationFrame(() => {
      if (sectionRef.current) {
        sectionRef.current.scrollIntoView({ behavior: "smooth" })
      }
    })
  }, [])
  const classes = useStyles({})
  const errorsDisplayed = compilationErrors
    // @ts-ignore
    .filter(error => (error.severity === "error" || error.errMessage))
    .slice(0, CONSTS.MAX_COMPILATION_ERRORS)

  return (
    <section style={{width: "100%"}} ref={sectionRef}>
      {!hideTitle && <><br />
      <h3>{t("compilation_failed")}</h3>
      <br /></>}
      {errorsDisplayed.map((error, i) => {
        console.log(errorsDisplayed.length)
        console.log(error + `${i}`)
        var errorLocation = error.formattedMessage.match(CONSTS.ERROR_LOCATION_REGEX)
        if (errorLocation) {
          var errorLocationStart = errorLocation?.index || 0 // = 0 (this should always be zero because the RegEx starts matching at start of string)
          var [errorLocationMatchingText] = errorLocation // the actual text that describes the file name and line number etc of the error
          var errorLocationTextLength = errorLocationMatchingText.length // how long this text is (including the colon and blank space at the end of it)
          var errorMessageWithoutErrorLocation = error.formattedMessage.slice(errorLocationTextLength) // the error message with the file location removed
          var errorLocationLengthWithoutColon = errorLocationTextLength - CONSTS.ERROR_LOCATION_REGEX_TRAILING_PUNCTUATION_COUNT // length of text with the colon and blank space at end removed
          var errorLocationMatchingTextWithoutColon = errorLocationMatchingText.slice(errorLocationStart, errorLocationLengthWithoutColon) // the text with the colon and blank space at end removed
          var [filePath, lineNumber] = errorMessageWithoutErrorLocation.split(":")
          var errorTypeMatch = errorMessageWithoutErrorLocation.match(`${error.type}: `)
          var errorMessageWithoutType = errorTypeMatch ? errorMessageWithoutErrorLocation.slice(errorTypeMatch[0].length) : errorMessageWithoutErrorLocation
        } else {
          // Errors like "Cannot compile your code. It is missing the pragma statement." 
          // made bugs because it doesn't contain location. So in that case we handle it.
          errorMessageWithoutType = error.formattedMessage
        }
        return (
          <List
            key={`errors-${error.formattedMessage}`}
            className={classes.compilationErrorList}
          >
            <ErrorListItem className={classes.compilationErrorListItem}>
              <ListItemAvatar>{errorAvatar()}</ListItemAvatar>
              <ListItemText
                primary={error.type}
                secondary={
                  <>
                    <code className={classes.compilationErrorItem}>
                      {errorMessageWithoutType}
                    </code>
                    {!scrollToSource &&
                      <div>{errorLocationMatchingTextWithoutColon}</div>
                    }
                    {scrollToSource &&
                      <Box>
                        <ClassicLink onClick={() => scrollToSource?.(Number(lineNumber), filePath)} >
                          {errorLocationMatchingTextWithoutColon}
                        </ClassicLink>
                      </Box>}
                  </>
                }
              />
            </ErrorListItem>
          </List>
        )
      })}
      <br />
      <br />
      <br />
    </section>
  )
}

CompilationErrorsBox = React.memo(CompilationErrorsBox)
export default CompilationErrorsBox